import { CheckoutTemplate } from "@/components/Templates";
import { useCheckoutPage } from "@/hooks/useCheckoutPage";

type CheckoutPageProps = {
  token: string;
};

export function CheckoutPage({ token }: CheckoutPageProps) {
  const checkout = useCheckoutPage(token);

  return <CheckoutTemplate {...checkout} />;
}
